<template>
    <div class="flex">
        <promocode
            class="flex-grow"
            @validated="
                ({ originalPromocode }) => (this.promocode = originalPromocode)
            "
            @removed="() => (this.promocode = null)"
        >
        </promocode>

        <btn
            v-if="promocode"
            class="bg-green text-white ml-6 px-6"
            @click="applyPromocode"
        >
            {{ $config("APPLY") }}
        </btn>
    </div>
</template>

<script>
import Promocode from "../components/Promocode";
import Btn from "../components/Btn";
import requestWithInteractions from "../mixins/requestWithInteractions";
import api from "../api";

export default {
    name: "promocode-preference",

    components: { Promocode, Btn },

    mixins: [requestWithInteractions],

    data() {
        return {
            promocode: null
        };
    },

    methods: {
        applyPromocode() {
            if (!this.promocode) return;

            this.sendRequest(api.applyPromocode(this.promocode), {
                beforeSendText: this.$config("APPLYING_PROMOCODE"),
                successText: this.$config("APPLIED_PROMOCODE"),

                onSuccess: () => {
                    this.promocode = null;

                    this.$router.push({ name: "preferences" });
                }
            });
        }
    }
};
</script>
